<!--富文本编辑框-->
<template>
    <div>
        <div class="editor-container">
            <!-- 图片上传组件辅助-->
            <!--<el-upload
                class="avatar-uploader"
                :action="serverUrl"
                name="img"
                :headers="header"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :before-upload="beforeUpload">
            </el-upload>-->

            <quill-editor 
                v-model="content" 
                ref="myQuillEditor" 
                :options="editorOption" 
                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                @change="onEditorChange($event)">
            </quill-editor>
        </div>
        <Warn ref="warn"></Warn>
    </div>
</template>
<script>
import {quillEditor} from 'vue-quill-editor'
import "quill/dist/quill.core.css"
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {uploadCommonFile} from "../../assets/js/modules/shareApi"
import loading from "@/assets/img/loading.gif"
import Warn from "../common/warn.vue"
export default {
  props: {
      isSend: {
          type: Boolean
      }
  },  
  data(){
      return {
        content: "",
        editorOption: {
            theme: "snow",
            placeholder: "在此插入文本",
        },
        nowIndexList: [],   //上传图片光标位置集合
        nowRangeIndex: 0,
    }
  },
  mounted(){
      this.previewImg();
  },
  components:{
      quillEditor,
      Warn
  },
  methods: {
      getContent(content){
        this.content = content;
      },
      //内容改变
      onEditorChange(el){
        this.$emit('getContent',{content: this.content, isSend: this.isSend});
      },
      onEditorBlur(){
        
      },
      onEditorFocus(el){

      },
      closeWarn(){
        this.$refs.warn.closeWarn();
      },
      //图片预览
      previewImg(){
        var quill = this.$refs.myQuillEditor.quill
        var toolbar = quill.getModule('toolbar');
        var that = this;
        toolbar.addHandler('image',function(){
            var fileInput = this.container.querySelector('input.ql-image[type=file]');
            if (fileInput == null) {
                fileInput = document.createElement('input');
                fileInput.setAttribute('type', 'file');
                fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                fileInput.classList.add('ql-image');   
                fileInput.addEventListener('change', function () {
                    if (fileInput.files != null && fileInput.files[0] != null) {
                        // var formData = new FormData();
                        // formData.append('file', fileInput.files[0]);
                        let file = fileInput.files[0];
                        let data = {};
                        data.FileExtension = file.name.substring(file.name.lastIndexOf('.')+1,file.name.length);
                        let formData = new window.FormData();
                        formData.append('File',file);
                        formData.append('FileExtension',data.FileExtension);
                        var range=quill.getSelection(true);   
                        quill.insertEmbed(range.index, 'image',loading);
                        quill.setSelection(range.index+1);   
                        that.nowRangeIndex = range.index;      
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function(res){
                            data.FileContent = reader.result; 
                            that.nowIndexList.push({"file":reader.result,"index": that.nowRangeIndex });
                            var nowIndex = "";
                            that.nowIndexList.some((v,i)=>{
                                if(v.file===data.FileContent){
                                    nowIndex =  i;
                                    return true;
                                }
                            });
                            uploadCommonFile(formData).then(function(res) {
                                quill.insertEmbed(that.nowIndexList[nowIndex].index+1, 'image',res.data.Data);
                                quill.deleteText(that.nowIndexList[nowIndex].index,1,'image');
                                quill.setSelection(that.nowIndexList[nowIndex].index+1);      
                                that.nowIndexList.splice(nowIndex,1);                           
                            },error=>{
                                quill.deleteText(that.nowIndexList[nowIndex].index,1,'image');
                                that.$refs.warn.message("图片上传失败!");
                            });
                            
                        }
                    }
                });
                this.container.appendChild(fileInput);
            }
            fileInput.click();
        
        });
      }
  }
}
</script>
<style scoped>
.editor-container>>>.ql-container{
    height: 450px;
}
</style>
<style>
.quill-editor{
    background-color: #f8f8f8;
    color: #666;
}
.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}
</style>




// WEBPACK FOOTER //
// src/components/common/quillEditor.vue